export const farmaciaRoutes = [
  {
    path: '/farmacia',
    name: 'Medicamentos',
    component: () =>
      import(
        /* webpackChunkName: "farmacia" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'mdiPill',
    typeIcon: 'mdi',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Medicamentos',
      requiresSession: true,
      perfiles: ['FARMACIA'],
      permiso: []
    },
    children: [
      {
        path: '/farmacia/dispensario',
        name: 'DispensarioIndexMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Dispensario/DispensarioIndex.vue'
          ),
        icon: 'mdiMedication',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Dispensario',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/farmacia/solicitudes',
        name: 'SolicitudesIndexMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Solicitudes/SolicitudesIndex.vue'
          ),
        icon: 'mdiFileSign',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Solicitudes Medicamentos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/farmacia/lotes',
        name: 'LotesIndexMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Lotes/LotesIndex.vue'
          ),
        icon: 'mdiPackageVariant',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Lotes Medicamentos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        }
      },
      {
        path: '/farmacia/lotes/:id',
        name: 'LotesViewMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Lotes/LotesView.vue'
          ),
        icon: 'mdiPackageVariant',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Lote',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA']
        }
      },
      {
        path: '/farmacia/inventario',
        name: 'InventarioIndexMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Inventario/InventarioIndex.vue'
          ),
        icon: 'mdiPillMultiple',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Inventario',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        }
      },
      {
        path: '/farmacia/inventario/:id',
        name: 'InventarioViewMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Inventario/InventarioView.vue'
          ),
        icon: 'mdiPillMultiple',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Inventario de medicamentos',
          requiresSession: true,
          perfiles: ['FARMACIA'],
          permiso: []
        }
      },
      {
        path: '/farmacia/equivalencias',
        name: 'EquivalenciasIndexMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Equivalencias/EquivalenciasIndex.vue'
          ),
        icon: 'mdiSwapHorizontal',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Equivalencias',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: true
        }
      },
      {
        path: '/farmacia/medicamentos-recetados',
        name: 'MedicamentosRecetadosIndex',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/MedicamentosRecetados/MedicamentosRecetadosIndex.vue'
          ),
        icon: 'mdiPillMultiple',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Medicamentos recetados',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: true
        }
      },
      {
        path: '/farmacia/actas',
        name: 'MediActasIndexMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Actas/MediActasIndex.vue'
          ),
        icon: 'mdiFileDocumentMultipleOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Actas Medicamentos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        }
      },
      {
        path: '/farmacia/considerandos/:key',
        name: 'ConsiderandosIndexMedicamentos',
        component: () =>
          import(
            /* webpackChunkName: "farmacia" */ '@/modules/Farmacia/views/Considerandos/ConsiderandosIndex.vue'
          ),
        icon: 'mdiTagText',
        typeIcon: 'mdi',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Considerandos Medicamentos',
          requiresSession: true,
          permiso: [],
          perfiles: ['FARMACIA'],
          showBackButton: false
        }
      }
    ]
  }
]
